// extracted by mini-css-extract-plugin
export default {"root":"PendingTooltip_root__lvb5q"};